import React from "react";
import tagImg from "../../../images/about-us/Tag-Icon.png";
import ShoppingCart from "../../../images/about-us/ShoppingCart-Icon.png";
import Inventory from "../../../images/about-us/Inventory-Icon.png";
import Rewards from "../../../images/about-us/Rewards-Icon.png";
import Shipping from "../../../images/about-us/Shipping-Icon.png";
import bgImage from "../../../images/about-us/CSC-LED-BackgroundImage2-BlueOverlay.jpeg";
import { Link } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";

type feature = {
  icon: string;
  text: string;
};

const title = `Tailored for You & Your Customers!`;
const description = `To make your ordering experience as smooth and efficient as possible, our industry-leading Online Distributor Portal simplifies, and enhances, your experience from start to finish.`;

const features: feature[] = [
  {
    icon: tagImg,
    text: "FREE Nationwide Shipping*",
  },
  {
    icon: ShoppingCart,
    text: "2% Off Online Orders",
  },
  {
    icon: Rewards,
    text: "Rewards For Your Customers",
  },
  {
    icon: Shipping,
    text: "Live Inventory Counts",
  },
  {
    icon: Shipping,
    text: "View Incoming Shipments",
  },
  {
    icon: tagImg,
    text: "Find Previous Orders",
  },
  {
    icon: Inventory,
    text: "View Order Details",
  },
  {
    icon: Shipping,
    text: "View ETAs & Branch Transfers",
  },
  {
    icon: Inventory,
    text: "Check Tracking Numbers",
  },
];

const AboutUsTailored = () => {
  return (
    <div
      className="nc-AboutUsTailored py-12 px-4 flex flex-col items-center bg-cover bg-[position:50%_0%] sm:bg-[position:0_50%] bg-inherit bg-fixed"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="pb-16">
        <h1 className="text-4xl md:text-5xl font-semibold text-white text-center mb-4">
          {title}
        </h1>
        <p className="text-base text-center max-w-3xl text-white">
          {description}
        </p>
      </div>
      <div className="container grid grid-cols-1 sm:grid-cols-3 w-full sm:w-5/6 gap-8 mb-16">
        {features.map((item) => (
          <div
            key={item.text}
            className="relative flex items-center justify-left bg-stone-100 text-csccolor rounded-2xl py-3 sm:pl-9 h-fit max-w-xs"
          >
            <div className="absolute bg-stone-100 -top-1 -left-4 w-14 h-14 rounded-full border border-csccolor p-3">
              <img className="h-full w-full object-contain" src={item.icon} />
            </div>
            <div className="text-sm font-normal tracking-tighter px-11 sm:px-2">
              {item.text}
            </div>
          </div>
        ))}
      </div>
      <ButtonSecondary
        className="text-sm font-medium w-full sm:w-fit"
        href="/signup"
      >
        Sign Up Today
      </ButtonSecondary>
    </div>
  );
};

export default AboutUsTailored;
